
import * as React from 'react';

import { MessageProvider } from "./message_context";
import { TokenProvider } from "./token_context";
import { PageContextProvider } from "./page_context";

import { TMBContainer } from "./util/tmb_container";

import { TokenEnterModal } from "./token_enter_modal";
import { TokenEditModal } from "./token_edit_modal";
import { CreateNewDataBaseModal, CreateNewDataBaseAction } from "./create_new_database_modal";
import { AccessTokenList } from "./tokens_list";
import { SubmitSessionForm } from "./session_submit";
import { BottomButtons } from "./bottom_buttons";
import { ParametersEditForm } from "./parameters_edit";

const BUN_PUBLIC_APPLICATION_TITLE = process.env.BUN_PUBLIC_APPLICATION_TITLE;


export function MainPage() {

    React.useEffect(() => {
        document.title = BUN_PUBLIC_APPLICATION_TITLE;
    }, []);

  return (
    <MessageProvider>
        <TokenProvider>
            <PageContextProvider>

                <div className="app overflow-hidden">

                    <TMBContainer>

                        <top className="p-3 b font-bold">
                            {BUN_PUBLIC_APPLICATION_TITLE}
                        </top>
                        <main className="bg-gray-100 p-4">
                            <AccessTokenList />
                            <SubmitSessionForm />
                            <ParametersEditForm />
                        </main>
                        <bottom className="flow-root p-4 bg-gray-200">
                            <BottomButtons />
                        </bottom>
                    </TMBContainer>

                </div>

                <TokenEnterModal />
                <CreateNewDataBaseModal />
                <TokenEditModal />
            </PageContextProvider>
        </TokenProvider>
    </MessageProvider>
  );
}


export default MainPage;
